import { ToolGroupManager } from '@cornerstonejs/tools';

const getViewportToolGroup = viewportId => ToolGroupManager.getToolGroup(viewportId);

export default getViewportToolGroup;
